/**
 * Add Spacing supports
 *
 * @param {Object} settings The block settings
 * @param {string} name The block name
 * @return {Object} The block settings
 */
function addImageSpacingSupport( settings, name ) {

	if ( name !== 'core/image' ) {

		return settings;

	}

	return {
		...settings,
		supports: {
			...settings.supports,
			spacing: {
				padding: [ 'top', 'bottom' ],
				margin: true,
			},
		},
	};

}

wp.hooks.addFilter(
	'blocks.registerBlockType',
	'wombat/supports/core-image-block',
	addImageSpacingSupport
);
